import { render, staticRenderFns } from "./ChangeSchoolPage.vue?vue&type=template&id=f3098046&scoped=true"
import script from "./ChangeSchoolPage.vue?vue&type=script&lang=js"
export * from "./ChangeSchoolPage.vue?vue&type=script&lang=js"
import style0 from "./ChangeSchoolPage.vue?vue&type=style&index=0&id=f3098046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3098046",
  null
  
)

export default component.exports